import {slide} from "../../library/slide";

export let modal = {
    show: showModal,
    hide: hideModal,
    toggle: toggleModal
};

function showModal(target) {
    target.className += ' tv-modal-open';
    let backdrop = document.createElement('div');
    backdrop.className += 'tvm-backdrop';
    backdrop.addEventListener('click', function() {hideModal(target);});
    document.body.appendChild(backdrop);
}

function hideModal(target) {
    target.classList.remove('tv-modal-open');
    let backdrop = document.getElementsByClassName('tvm-backdrop')[0];
    backdrop.parentNode.removeChild(backdrop);
}

function toggleModal(target) {
    if (window.getComputedStyle(target).display === 'none') {
        return showModal(target);
    } else {
        return hideModal(target);
    }
}